import { AccountId, AssetType } from "caip";
import LitJsSdk from "lit-js-sdk";
import { ethers } from "ethers";
const CHAINS = Object.keys(LitJsSdk.LIT_CHAINS)
    .map((k) => {
    return { [LitJsSdk.LIT_CHAINS[k].chainId.toString()]: k };
})
    .reduce((prev, cur) => {
    return { ...prev, ...cur };
});
export function accountIdToUserId(accountId) {
    return accountId.toString().replaceAll(":", "_");
}
export function accountIdFromUserId(userId) {
    const _accountId = new AccountId(AccountId.parse(userId.replaceAll("_", ":")));
    _accountId.address = ethers.utils.getAddress(_accountId.address);
    return _accountId;
}
export function assetIdToChannelId(assetId) {
    return assetId.toString().replaceAll(":", "_").replaceAll("/", "-");
}
export function assetIdFromChannelId(channelId) {
    return new AssetType(channelId.replaceAll("_", ":").replaceAll("-", "/"));
}
export function getChainFromAccountId(accountId) {
    if (accountId.chainId.namespace === "eip155") {
        return CHAINS[accountId.chainId.reference];
    }
    else if (accountId.chainId.namespace === "solana") {
        return "solana";
    }
    else {
        throw new Error("Unknown chain");
    }
}
export function safeAccountIdToChannelId(accountId) {
    return `safe_${accountId
        .toString()
        .replaceAll(":", "_")
        .replaceAll("/", "-")}`;
}
export function safeAccountIdFromChannelId(channelId) {
    return new AccountId(AccountId.parse(channelId.replace("safe_", "").replace("gno_", "").replaceAll("_", ":")));
}
export function poapAccountIdToChannelId(accountId) {
    return `poap_${accountId
        .toString()
        .replaceAll(":", "_")
        .replaceAll("/", "-")}`;
}
export function poapAccountIdFromChannelId(channelId) {
    return new AccountId(AccountId.parse(channelId.replace("poap_", "").replaceAll("_", ":")));
}
export function poapEventIdFromChannelId(channelId) {
    const matches = channelId.split("_"); // 'poap_eip155_100_541620'
    return matches[3];
}
export function nftAccountIdFromChannelId(channelId) {
    // changed to follow the CAIP-74 spec and reverse from getstream channelId format
    const nftAssetId = assetIdFromChannelId(channelId);
    // TODO: Remove the hard-coding and verify the casing of the standard
    if (nftAssetId.assetName.namespace === "erc721") {
        return new AccountId({
            chainId: nftAssetId.chainId,
            address: nftAssetId.assetName.reference,
        });
    }
}
